import Orders from '../layout/Guest/OrderList'
import ChapelTabs from '../layout/ChapelTabs'
import OrderOptionsSorting from '../common/option-sorting/OrderOptionsSorting'

export default function OrdersStatus() {

    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-3 lg:space-y-4 overflow-hidden'>
            <ChapelTabs />
            <OrderOptionsSorting/>
            <Orders/>
        </div>
    )
}
